module.exports = __webpack_public_path__ + "img/icon_mark_position.c6f712f9.png";